const a=({slug:a,cfhMetadataBySlugPath:t,defaultName:e=""})=>t&&t[a]?.name||e;export{a as getLocalizedHierarchyNameBySlugPath};
